import { createElement, FC } from 'react';
import OutlinedFacebookIcon from '@menuzen/icon/build/outline/Facebook';
import OutlinedTwitterIcon from '@menuzen/icon/build/outline/Twitter';
import OutlinedInstagramIcon from '@menuzen/icon/build/outline/Instagram';
import OutlinedYoutubeIcon from '@menuzen/icon/build/outline/Youtube';
import OutlinedFacebookMessengerIcon from '@menuzen/icon/build/outline/Messenger';
import OutlinedWhatsAppIcon from '@menuzen/icon/build/outline/Whatsapp';
import OutlinedMailIcon from '@menuzen/icon/build/outline/Email';
import SolidMailIcon from '@menuzen/icon/build/solid/Email';
import SolidFacebookIcon from '@menuzen/icon/build/solid/Facebook';
import SolidTwitterIcon from '@menuzen/icon/build/solid/Twitter';
import SolidInstagramIcon from '@menuzen/icon/build/solid/Instagram';
import SolidYoutubeIcon from '@menuzen/icon/build/solid/Youtube';
import SolidFacebookMessengerIcon from '@menuzen/icon/build/solid/Messenger';
import SolidWhatsAppIcon from '@menuzen/icon/build/solid/Whatsapp';

interface SocialIconProps {
    type?: 'outline' | 'solid';
    social: string;
}

const icons = {
    outlined: {
        MAIL: OutlinedMailIcon,
        FACEBOOK: OutlinedFacebookIcon,
        TWITTER: OutlinedTwitterIcon,
        INSTAGRAM: OutlinedInstagramIcon,
        YOUTUBE: OutlinedYoutubeIcon,
        FACEBOOK_MESSENGER: OutlinedFacebookMessengerIcon,
        WHATSAPP: OutlinedWhatsAppIcon,
    },
    solid: {
        MAIL: SolidMailIcon,
        FACEBOOK: SolidFacebookIcon,
        TWITTER: SolidTwitterIcon,
        INSTAGRAM: SolidInstagramIcon,
        YOUTUBE: SolidYoutubeIcon,
        FACEBOOK_MESSENGER: SolidFacebookMessengerIcon,
        WHATSAPP: SolidWhatsAppIcon,
    },
};
const SocialIcon: FC<SocialIconProps> = ({ social, type = 'outlined' }) => {
    return createElement(icons[type][social]);
};

export default SocialIcon;
